import React, { useEffect, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { KeyRound, CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const userId = params.get("u");
  const token = params.get("t");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [email, setEmail] = useState("");

  useEffect(() => {
    const m = document.createElement("meta");
    m.name = "robots"; m.content = "noindex,nofollow";
    document.head.appendChild(m);
    return () => document.head.removeChild(m);
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) return toast.error("Password minimo 6 caratteri");
    if (pw !== pw2) return toast.error("Le password non coincidono");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/password-reset/confirm", { user_id: userId, token, new_password: pw });
      setEmail(data.email); setDone(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Link non valido o scaduto");
    } finally { setBusy(false); }
  };

  if (!userId || !token) {
    return (
      <div className="min-h-[70vh] flex items-center justify-center px-6">
        <div className="max-w-md w-full bg-white border border-border rounded-3xl p-10 text-center shadow-xl">
          <XCircle className="w-14 h-14 text-red-600 mx-auto mb-3" />
          <h1 className="font-display text-2xl font-bold mb-2">Link non valido</h1>
          <p className="text-sm text-muted-foreground mb-6">Manca il token di reset. Richiedi un nuovo link.</p>
          <Link to="/auth"><Button variant="outline" className="rounded-full w-full">Torna al login</Button></Link>
        </div>
      </div>
    );
  }

  if (done) {
    return (
      <div className="min-h-[70vh] flex items-center justify-center px-6">
        <div className="max-w-md w-full bg-white border border-border rounded-3xl p-10 text-center shadow-xl">
          <div className="w-16 h-16 rounded-2xl bg-green-100 flex items-center justify-center mx-auto mb-4">
            <CheckCircle2 className="w-9 h-9 text-green-600" />
          </div>
          <h1 className="font-display text-2xl font-bold mb-2">Password aggiornata 🎉</h1>
          <p className="text-sm text-muted-foreground mb-6">Puoi accedere subito con la nuova password su <strong>{email}</strong>.</p>
          <Button onClick={() => nav("/auth")} className="rounded-full bg-[#005C7A] hover:bg-[#004A63] w-full" data-testid="pw-reset-login">Vai al login</Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6">
      <div className="max-w-md w-full bg-white border border-border rounded-3xl p-10 shadow-xl">
        <div className="w-14 h-14 rounded-2xl bg-[#005C7A] flex items-center justify-center mb-5"><KeyRound className="w-7 h-7 text-white" /></div>
        <h1 className="font-display text-3xl font-bold mb-1">Reimposta password</h1>
        <p className="text-sm text-muted-foreground mb-6">Scegli una nuova password sicura per il tuo account.</p>
        <form onSubmit={submit} className="space-y-4">
          <div><Label>Nuova password</Label><Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} minLength={6} autoFocus data-testid="pw-reset-new" /></div>
          <div><Label>Ripeti password</Label><Input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} minLength={6} data-testid="pw-reset-confirm" /></div>
          <Button type="submit" disabled={busy || !pw || pw !== pw2} className="w-full rounded-full bg-[#005C7A] hover:bg-[#004A63]" data-testid="pw-reset-submit">
            {busy ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Aggiornamento…</> : "Reimposta password"}
          </Button>
        </form>
      </div>
    </div>
  );
}
